import Vue from 'vue';
import { Direction } from '../../enums';
import router from '../../router/index'

const state = {
  currentStep: 0,
  allData: null,
  initialState: null,
  id: 0,
  log: [],
  logline: '',
  lineNumber: 0,
  msg: '',
  valid: true,
  win: false,
  players: {
    0: {
      coordinate: {
        second: 1,
        first: 1,
      },
      direction: 'NORTH',
      health: 10,
    },
  },
  boundary: {
    second: { second: 4, first: 4 },
    first: { second: 0, first: 0 },
  },
  exits: [
    {
      second: 4,
      first: 4,
    },
  ],
  start: {
    second: 0,
    first: 0,
  },
  tiles: [],
  renderBoard: true, // tick to rerender the board
};

const getters = {
  hasNextStep(state) {
    if (state.allData == null) {
      return false;
    }
    return state.currentStep < state.allData.length;
  },
  getCurrentLine(state) {
    return state.lineNumber;
  }
};

const actions = {
  render({ state }) {
    state.renderBoard = !state.renderBoard;
  },
  register({ rootState }) {
    Vue.prototype.$socket.sendObj({
      type: 'REGISTER',
      name: rootState.user.name,
      color: rootState.user.owlColor,
    });
  },
  authenticate(_, { key }) {
    Vue.prototype.$socket.sendObj({
      type: 'AUTHENTICATE',
      key
    });
  },
  updateUser({ rootState }) {
    Vue.prototype.$socket.sendObj({
      type: 'UPDATE_USER',
      name: rootState.user.name,
      color: rootState.user.owlColor,
      headAcc: rootState.user.headAccessoir,
      bodyAcc: rootState.user.bodyAccessoir,
    });
  },
  chooseTask(ctx, { task }) {
    // console.log('chooseTask', task);
    Vue.prototype.$socket.sendObj({
      type: 'INIT',
      json_map: task.json_map,
      health: task.health,
      direction: Direction.NORTH,
      taskId: task.id,
    });
  },
  turnLeft({ state }) {
    Vue.prototype.$socket.sendObj({
      type: 'TURN_LEFT',
    });
    state.renderBoard = !state.renderBoard;
  },
  turnRight({ state }) {
    Vue.prototype.$socket.sendObj({
      type: 'TURN_RIGHT',
    });
    state.renderBoard = !state.renderBoard;
  },
  move({ state }) {
    Vue.prototype.$socket.sendObj({
      type: 'MOVE',
    });
    state.renderBoard = !state.renderBoard;
  },
  sendInstructions(ctx, { instructions, taskID, solution, language }) {
    Vue.prototype.$socket.sendObj({
      type: "TASK",
      instructions,
      solution,
      language,
      taskID
    });
  },
  shutdown() {
    Vue.prototype.$socket.sendObj({
      type: 'SHUTDOWN',
    });
  },
  setStep({ state, dispatch }) {
    if (state.currentStep === 0 && state.initialState !== null) {
      Object.entries(state.initialState).forEach(([key, entry]) => {
        state[key] = entry;
      });
      state.log = [];
    } else if (state.allData !== null && state.allData.length > state.currentStep - 1) {
      const next_state = state.allData[state.currentStep - 1];
      Object.entries(next_state).forEach(([key, entry]) => {
        if (key !== 'log')
          state[key] = entry;
      });
      state.log.push(state.logLine);
    }
    dispatch('render');
  },
  nextStep({ getters, commit, dispatch }) {
    if (getters.hasNextStep) {
      console.log('triggering next step');
      commit('incrementStep');
      dispatch('setStep');
    } else {
      console.warn('Call nextStep when !hasNextStep');
    }
  },
  resetStep({ commit, dispatch }) {
    commit('resetStep');
    dispatch('setStep');
  },
};

const mutations = {
  incrementStep(state) {
    state.currentStep += 1;
  },
  resetStep(state) {
    state.currentStep = 0;
  },
  setWin(state, win) {
    state.win = win;
  },
  setValid(state, valid){
    state.valid = valid;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
